"use strict";
exports.__esModule = true;
//# sourceMappingURL=message-template.type.js.map